<template>
  <div>
    <b-textarea
      v-model="comment"
      label="Коментар"
      :error-messages="getErrorMessages(v$.comment)"
      @blur="v$.comment.$touch()"></b-textarea>
  </div>
</template>

<script setup lang="ts">
import { Dialog } from '@/dialog'
import { BTextarea } from 'best-modules/components'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { documentReturnFromReview } from '@/requests/document'
import { getErrorMessages } from 'best-modules/utils'

defineOptions({
  name: 'DocumentReturnFromReview',
})

const props = defineProps<{
  dialog: Dialog
}>()

const comment = ref()

const v$ = useVuelidate({ comment: { required } }, { comment })
const submit = () => {
  return documentReturnFromReview(props.dialog.dialogData.reviewId, {
    comment: comment.value,
  })
}

defineExpose({
  v$,
  submit,
})
</script>
